import { render, staticRenderFns } from "./BankSelector.vue?vue&type=template&id=57ebbe30&scoped=true"
import script from "./BankSelector.vue?vue&type=script&lang=js"
export * from "./BankSelector.vue?vue&type=script&lang=js"
import "./BankSelector.vue?vue&type=style&index=0&id=57ebbe30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ebbe30",
  null
  
)

export default component.exports